import React from "react";

const PapelDelegadosSeccionais = () => {
  return (
    <section className="  py-10 px-4">
      <div className="  mx-auto text-center">
        {/* Título */}
        <h2 className="text-xl sm:text-xl font-bold mb-2">
          O PAPEL DOS DELEGADOS SECCIONAIS
        </h2>

        {/* Linha amarela */}
        <div className="w-24 h-1 bg-[#f6b100] mx-auto mb-6" />

        {/* Texto */}
        <div className="text-justify text-sm sm:text-base text-gray-700 space-y-3">
          <p>
            O Delegado Seccional é a voz dos cooperados na COOPERFORTE: ele representa os interesses coletivos,
            participa de discussões estratégicas e contribui para definir os caminhos da cooperativa. Seu papel é
            essencial para garantir que as decisões tomadas estejam alinhadas às necessidades dos cooperados.
          </p>
          <p>
            Presente ativamente nas Assembleias, o Delegado leva sugestões, ideias e soluções, sendo um elo direto entre
            a base e a gestão. É por meio dele que os cooperados têm voz nas decisões que impactam o presente e o futuro
            da COOPERFORTE.
          </p>
          <p>
            Ao votar na eleição de Delegados, você estará contribuindo diretamente para o futuro da COOPERFORTE e a
            melhoria contínua da sua cooperativa.
          </p>
        </div>
      </div>
    </section>
  );
};

export default PapelDelegadosSeccionais;
